var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLands(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 8.60866C14.9998 10.7511 17.1873 13.5056 17.1873 13.5056C17.1873 13.5056 19.3748 10.7511 19.3748 8.60866C19.3748 7.59446 18.4373 6.46624 17.1873 6.46624C15.9373 6.46624 14.9998 7.59446 14.9998 8.60866ZM14.9998 8.60866H1M1 17.45H21.9997M7.82492 3.7L7.82293 22.95M19.4363 8.65H22M3.17441 2.06286L7.57548 3.32741C7.85415 3.40747 8.14568 3.40747 8.42435 3.32741L14.5754 1.56005C14.8541 1.47998 15.1456 1.47998 15.4243 1.56005L20.6742 3.06849C21.4532 3.29233 21.9997 4.0968 21.9997 5.0197V20.9859C21.9997 22.2944 20.9298 23.2545 19.8253 22.9371L15.4243 21.6726C15.1456 21.5925 14.8541 21.5925 14.5754 21.6726L8.42435 23.4399C8.14568 23.52 7.85415 23.52 7.57548 23.4399L2.32555 21.9315C1.54651 21.7077 1 20.9032 1 19.9803V4.01407C1 2.7056 2.06992 1.74552 3.17441 2.06286Z",
    stroke: "#4B4B4A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLands);
export default __webpack_public_path__ + "static/media/lands.ccdabc815c9be0c9763d53d3f99323b6.svg";
export { ForwardRef as ReactComponent };